import React from 'react';
import { theme } from 'lib/theme';
import { StyleProp, View, ViewStyle } from 'react-native';
import { ViewWithSeparators } from './ViewWithSeparators';
import { BUTTON_HEIGHT, Button, ButtonTheme } from './Button';
import { ICONS } from './Icon';
import { Menu } from './Menu';

type Props = {
  selectionState: 'none' | 'all' | 'some';
  onSelectAll: () => void;
  onSelectNone: () => void;
  style?: StyleProp<ViewStyle>;
  buttonStyle?: StyleProp<ViewStyle>;
  hideMenu?: boolean;
};

export const ListSelectAllCheckbox: React.FC<Props> = ({
  selectionState,
  onSelectAll,
  onSelectNone,
  style,
  buttonStyle,
  hideMenu = false,
}) => {
  const CheckboxButton = (
    <Button
      style={[
        { alignSelf: 'stretch', borderRadius: hideMenu ? 4 : 0 },
        buttonStyle,
      ]}
      icon={
        selectionState === 'some'
          ? ICONS.SquareMinusLight
          : selectionState === 'all'
            ? ICONS.SquareCheckSolid
            : ICONS.SquareLight
      }
      buttonTheme={ButtonTheme.themeless}
      onPress={selectionState === 'none' ? onSelectAll : onSelectNone}
      accessibilityHint={
        selectionState === 'none'
          ? 'Selects all items in list'
          : 'Deselects all items in list'
      }
    />
  );

  if (hideMenu) {
    return <View style={style}>{CheckboxButton}</View>;
  }

  return (
    <ViewWithSeparators
      horizontal
      separatorColor="transparent"
      style={[
        {
          marginRight: theme.paddingHorizontal,
          backgroundColor: theme.colors.blue10,
          borderRadius: 4,
          overflow: 'hidden',
          minHeight: BUTTON_HEIGHT,
          alignItems: 'stretch',
        },
        style,
      ]}
    >
      {CheckboxButton}
      <Menu
        buttonConfig={{
          style: {
            alignSelf: 'stretch',
            paddingLeft: theme.paddingHorizontalHalf,
            paddingRight: theme.paddingHorizontalHalf,
            borderRadius: 0,
          },
          icon: ICONS.CaretDownSolid,
          buttonTheme: ButtonTheme.themeless,
          iconSize: 12,
        }}
        options={[
          {
            text: 'Select All',
            icon: ICONS.SquareCheckSolid,
            onPress: onSelectAll,
          },
          {
            text: 'Select None',
            icon: ICONS.SquareLight,
            onPress: onSelectNone,
          },
        ]}
      />
    </ViewWithSeparators>
  );
};
